import asyncActionTypes from '../actions/types.js';

const initialState = {
  errorElegibility: null,
  iropElegibility: false,
  iropElegibilityInfo: null,
  loadingIropsElegibility: false,
};

const iropsElegibility = (state = initialState, action) => {
  switch (action.type) {
    case asyncActionTypes.RETRIEVE_IROPS_ELEGIBILITY.START:
      return {
        ...state,
        loadingIropsElegibility: true,
      };
    case asyncActionTypes.RETRIEVE_IROPS_ELEGIBILITY.SUCCESS:
      return {
        ...state,
        iropElegibility: action.payload.eligibility,
        iropElegibilityInfo: action.payload,
        loadingIropsElegibility: false,
      };
    case asyncActionTypes.RETRIEVE_IROPS_ELEGIBILITY.FAIL:
      return {
        ...state,
        loadingIropsElegibility: false,
        errorElegibility: action.payload,
      };
    default:
      return state;
  }
};

export default iropsElegibility;